export const EVERY_PERMISSION = "all";

export const ADMIN_ACCESS: readonly string[] = [EVERY_PERMISSION];

export const PROPERTY_MANAGER_ACCESS: readonly string[] = [
  "properties.view",
  "properties.create",
  "properties.update",
  "properties.delete",
  "properties.upload_images",
  "property_units.view",
  "property_units.create",
  "property_units.update",
  "property_units.delete",
  "vendors.view",
  "appointments.view",
  "appointments.create",
  "appointments.update",
  "appointments.assign",
  "appointments.cancel",
  "appointments.reschedule",
  "property_users.view",
  "property_users.assign",
  "property_users.remove",
  "roles.view",
  "team_members.view",
];

export type RoleMeaning = "admin" | "propertyManager" | "member";

export type GrantedRole = Exclude<RoleMeaning, "member">;

export type StaffRole = "admin" | "property_manager";

const ROLE_OF_STAFF: Readonly<Record<StaffRole, GrantedRole>> = { admin: "admin", property_manager: "propertyManager" };

const STAFF_ROLE_OF: Readonly<Record<GrantedRole, StaffRole>> = { admin: "admin", propertyManager: "property_manager" };

export const roleOfStaff = (role: StaffRole): GrantedRole => ROLE_OF_STAFF[role];

export const staffRoleFor = (role: GrantedRole): StaffRole => STAFF_ROLE_OF[role];

export type OrganizationTypeCode = "pmc" | "vendor" | "subs";

export const ROLES_OFFERED: Readonly<Record<OrganizationTypeCode, readonly GrantedRole[]>> = {
  pmc: ["admin", "propertyManager"],
  vendor: ["admin"],
  subs: ["admin"],
};

export const WORKER_ROLES_OFFERED: readonly GrantedRole[] = ["admin"];
